import { useEnvironmentType } from "../../contexts/useEnvType";
import { IntegrationType, useIntegrationsQuery } from "../../types";

export const useHasIntegration = (type: IntegrationType) => {
  const { isGov } = useEnvironmentType();
  const { data } = useIntegrationsQuery({
    skip: isGov,
  });

  return Boolean(data && data.integrations.includes(type));
};
